import MyLeftMenu from './leftMenu.vue';

MyLeftMenu.install = function(Vue){
  Vue.component('MyLeftMenu', MyLeftMenu);
};

export default MyLeftMenu;